
import React, { useContext, useMemo } from 'react';

import { BasicData } from '@App';
import { Trans } from '@lingui/macro';
import { getFormattedDate, addClickableLinks } from '@utils/Utils';

import './style.scss';

const IntroductionComponent = () => {
    const { summary, start_date, end_date } = useContext(BasicData);

    return useMemo(() => (
        <div className="trip-summary-introduction bg-white">
            <h6>{getFormattedDate(start_date, end_date)}</h6>
            <h2 className="text-md-center mb-[1.875rem]"><Trans>Introduction</Trans></h2>
            <div className='break-words' dangerouslySetInnerHTML={{ __html: addClickableLinks(summary) }} />
        </div>
    ), [end_date, start_date, summary])
}

export default IntroductionComponent;